let preloader = document.getElementById('preloader');
if (preloader) {
  window.addEventListener('DOMContentLoaded', function() {
    let test = 0;
    if (test === 0) {
      test = 1;
      let elem = document.getElementById('preloader-icon-stop');
      let width = 1;
      let id = setInterval(frame, 5)

      function frame() {
        if (width >= 100) {
          clearInterval(id);
          test = 0;
          preloader.classList.add('preloader--loaded');
        } else {
          width++;
          elem.setAttribute('offset', width + "%");
        }
      }
    }
  })
}